"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeComposerHelperUpdater = exports.ComposerHelperNames = void 0;

var _editorChangeHelpers = require("composer-lib/lib/helpers/editorChangeHelpers");

var _saveHelpers = require("composer-lib/lib/helpers/saveHelpers");

var ComposerHelperNames = {
  DEBOUNCED_SAVE_CHANGED_COMPOSITION: 'debouncedSaveChangedComposition',
  SAVE_CHANGED_COMPOSITION: 'saveChangedComposition',
  ON_INSERT_IMAGE_CHANGE: 'onInsertImageChange',
  ON_INSERT_VIDEO_CHANGE: 'onInsertVideoChange',
  ON_INSERT_EMBED_CHANGE: 'onInsertEmbedChange',
  ON_INSERT_QUESTION_AND_ANSWER: 'onInsertQuestionAndAnswerChange'
}; // Updates specified (as list fn names) save + editorChange helpers on component instance
// Component instance must be passed when creating this updater so it has access to props
// Also, component must have the the right props (check specific helper functions for what they expect)

exports.ComposerHelperNames = ComposerHelperNames;

var makeComposerHelperUpdater = function makeComposerHelperUpdater(component, helperNames) {
  return function (givenProps) {
    var props = givenProps || component.props;
    var saveChangedComposition = (0, _saveHelpers.makeSaveChangedComposition)(props);
    var debouncedSaveChangedComposition = (0, _saveHelpers.makeDebouncedSaveChangedComposition)(props);

    if (helperNames.includes(ComposerHelperNames.SAVE_CHANGED_COMPOSITION)) {
      component[ComposerHelperNames.SAVE_CHANGED_COMPOSITION] = saveChangedComposition;
    }

    if (helperNames.includes(ComposerHelperNames.DEBOUNCED_SAVE_CHANGED_COMPOSITION)) {
      component[ComposerHelperNames.DEBOUNCED_SAVE_CHANGED_COMPOSITION] = debouncedSaveChangedComposition;
    }

    if (helperNames.includes(ComposerHelperNames.ON_INSERT_IMAGE_CHANGE)) {
      component[ComposerHelperNames.ON_INSERT_IMAGE_CHANGE] = (0, _editorChangeHelpers.makeInsertImageChangeHandler)(props.insertImage);
    }

    if (helperNames.includes(ComposerHelperNames.ON_INSERT_VIDEO_CHANGE)) {
      component[ComposerHelperNames.ON_INSERT_VIDEO_CHANGE] = (0, _editorChangeHelpers.makeInsertVideoChangeHandler)(props.insertVideo);
    }

    if (helperNames.includes(ComposerHelperNames.ON_INSERT_EMBED_CHANGE)) {
      component[ComposerHelperNames.ON_INSERT_EMBED_CHANGE] = (0, _editorChangeHelpers.makeInsertEmbedChangeHandler)(props.insertEmbed);
    }

    if (helperNames.includes(ComposerHelperNames.ON_INSERT_QUESTION_AND_ANSWER)) {
      component[ComposerHelperNames.ON_INSERT_QUESTION_AND_ANSWER] = (0, _editorChangeHelpers.makeInsertQuestionAndAnswerChangeHandler)(props.insertQuestionAndAnswer);
    }
  };
};

exports.makeComposerHelperUpdater = makeComposerHelperUpdater;